import desktopHero from '../assets/Whisk_couple-open-door-launch-hero.png';
import mobileHero from '../assets/Whisk_couple-portrait.png';

export { desktopHero, mobileHero };

/**
 * Returns the correct hero asset based on viewport width.
 * @param {number} viewportWidth
 * @returns {string} image src
 */
export function selectHeroAsset(viewportWidth) {
  return viewportWidth >= 768 ? desktopHero : mobileHero;
}

/**
 * Computes scroll progress [0, 1] for a section.
 * @param {number} scrollY - window.scrollY
 * @param {number} offsetTop - section's offsetTop
 * @param {number} sectionHeight - section's offsetHeight
 * @param {number} viewportHeight - window.innerHeight
 * @returns {number} clamped progress in [0, 1]
 */
export function computeScrollProgress(scrollY, offsetTop, sectionHeight, viewportHeight) {
  const denominator = Math.max(sectionHeight - viewportHeight, 1);
  const raw = (scrollY - offsetTop) / denominator;
  return Math.min(1, Math.max(0, raw));
}

/**
 * Computes parallax scale from progress.
 * @param {number} progress - [0, 1]
 * @param {boolean} reducedMotion
 * @returns {number} scale value
 */
export function computeParallaxScale(progress, reducedMotion = false) {
  return reducedMotion ? 1 : 1 + 0.075 * progress;
}

/**
 * Computes cross-fade opacity for the top image.
 * @param {number} progress - [0, 1]
 * @param {boolean} reducedMotion
 * @returns {number} opacity value
 */
export function computeCrossFadeOpacity(progress, reducedMotion = false) {
  return reducedMotion ? 1 : 1 - progress;
}
